<template>
	<div>
		<div class="SwiperTowStyle">
			<div style="width: 1200px; margin: 0 auto ; display: flex;">
				<div class="SwiperTowStyleLeft">
					<SwiperTow></SwiperTow>
				</div>
				<div class="RealTimeinfoTowRight">
					<RealTimeinfoTow :InformationArr="InformationArr"></RealTimeinfoTow>
				</div>
			</div>
		</div>
		<!-- style="background-color: #FF8080; border: 1px solid transparent"  -->


		<div class="WarningCenterStyle">
			<WarningCenterNew></WarningCenterNew>
		</div>


		<!-- <div v-if="WarningData.length != 0&&isWarnning">
			<div class="WarningCenterStyle">
				<WarningTow :WarningData="WarningData" @TitleClick="TitleClick"></WarningTow>
			</div>
		</div> -->


		<!-- 只有这里是图表 -->
		<!-- <div class="IndexCenterStyle">
			<IndexCenter :dataListHot="dataListHot" :QuarterAmount="QuarterAmount" :Quarter="Quarter"
				:StockCost="StockCost" @load="getLoadData"></IndexCenter>
		</div> -->

		<div class="DownloadMaterialsStyle" v-if="SwiperList.length != 0">
			<DownloadMaterials ref="DownloadMaterials" :SwiperList="SwiperList"></DownloadMaterials>
		</div>
		<div class="CompanyprofileStyle">
			<Companyprofile></Companyprofile>
		</div>
		<InvoiceReminder />
		<!-- <GoTop></GoTop> -->
		<TipsDialog isOpen />
	</div>
</template>



<script>
	import SwiperTow from "./components/swiperTow.vue"
	import Swiper from "./components/swiper.vue"
	import WarningCenter from "./components/warningCenter.vue"

	///旧版预警中心
	//import WarningTow from './components/warningCenterComponents/warning/warningTow.vue'
	import WarningCenterNew from './components/warningCenterComponents/warning/WarningCenterNew.vue'

	import IndexCenter from "./components/indexCenterComponents/IndexCenterTop/IndexCenterTop.vue"
	import DownloadMaterials from './components/DownloadMaterials.vue'
	import Companyprofile from './components/Companyprofile.vue'
	import InvoiceReminder from './components/InvoiceReminder.vue'
	import RealTimeinfo from "./components/warningCenterComponents/Real-timeinfo/Real-timeinfo.vue"
	import RealTimeinfoTow from "./components/warningCenterComponents/Real-timeinfo/Real-timeinfoTow.vue"
	import GoTop from '../GoTop/goTop.vue'
	import TipsDialog from '../components/TipsDialog.vue'
	import {
		CusType,
		InformationList
	} from '@/api/home'
	import {
		DataDownloadListApi,
		HomeRemindGetForWarning,
	} from '@/api/channel'
	import {
		QuotaReportProvinceSalesAmount,
		QuotaReportYearSalesAmount,
		QuotaReportPurchaseQuotaSummary,
		QuotaReportStockCostSummary
	} from '@/api/echartsApi'
	export default {
		components: {
			SwiperTow,
			Swiper,
			WarningCenter,
			IndexCenter,
			DownloadMaterials,
			Companyprofile,
			InvoiceReminder,
			GoTop,
			RealTimeinfo,
			RealTimeinfoTow,
			TipsDialog,
			WarningCenterNew
			//
			//WarningTow,
		},
		computed: {
			webMenus() {
				return this.$store.state.MenusData.CusWebMenus;
			}
		},
		data() {
			return {
				CusTypestate: null,
				SwiperList: [],
				WarningData: [],
				InformationArr: [],
				dataListHot: {},
				StockCost: null,
				QuarterAmount: null,
				Quarter: null,
				YearStr: '0',
				Type: '',
				CanShow: true,
				WarningFalg: false,
				SwiperListDownloadFalg: false,
				InformationArrFalg: false,
				loading: undefined,
				isWarnning: false,
			}
		},
		created() {
			let indexAuth = this.webMenus.filter(it => it.NodeName === '首页')[0];
			this.isWarnning = indexAuth.Buttons.map(it => it.NodeName).includes('warning');
			// this.loading = this.$loading({
			// 	lock: true,
			// 	text: '加载中...',
			// 	spinner: 'el-icon-loading',
			// 	background: 'rgba(255,255,255,0.3)'
			// });

		},
		mounted() {
			this.CusType()
			this.DataDownloadListApi()
			this.InformationList()
			//this.QuotaReportProvinceSalesAmount()// 热力图


			// this.QuotaReportYearSalesAmount()
			// this.QuotaReportPurchaseQuotaSummary()
			// this.QuotaReportStockCostSummary()

			//旧版预警 
			//this.HomeRemindGetForWarning()
		},
		methods: {
			//整体加载图表数据
			getLoadData(e) {
				//this.QuotaReportProvinceSalesAmount()// 热力图
				this.QuotaReportYearSalesAmount(e)
				this.QuotaReportPurchaseQuotaSummary(e)
				this.QuotaReportStockCostSummary(e)
			},
			// 热力图
			async QuotaReportProvinceSalesAmount(e = {}) {
				let {
					data,
					message,
					code
				} = await QuotaReportProvinceSalesAmount(e)
				if (code == 0) {
					this.CanShow = data.CanShow
					this.dataListHot = data
				} else {
					this.$message.warning(message)
				}
			},
			// 首页年度销售额
			async QuotaReportYearSalesAmount(e = {}) {
				let {
					data,
					message,
					code
				} = await QuotaReportYearSalesAmount(e)
				if (code == 0) {
					Object.assign(data, {
						type: 'SalesAmount'
					})
					this.QuarterAmount = data
				} else {
					this.$message.warning(message)
				}
			},
			// 首页年度采购指标达成率
			async QuotaReportPurchaseQuotaSummary(e = {}) {
				let {
					data,
					message,
					code
				} = await QuotaReportPurchaseQuotaSummary(e)
				if (code == 0) {
					Object.assign(data, {
						type: 'QuotaSummary'
					})
					this.Quarter = data
				} else {
					this.$message.warning(message)
				}
			},
			// 首页库存透视参考价格合计
			async QuotaReportStockCostSummary(e = {}) {
				let {
					data,
					message,
					code
				} = await QuotaReportStockCostSummary(e)
				if (code == 0) {
					// Object.assign(data, { type: 'QuotaSummary' })
					this.StockCost = data
				} else {
					this.$message.warning(message)
				}
			},

			// 资讯列表
			async InformationList() {
				let {
					code,
					message,
					data
				} = await InformationList({
					pageSize: 3,
					pageIndex: 1
				})
				if (code == 0) {
					this.InformationArr = data.data
					this.InformationArrFalg = true
					if (this.WarningFalg && this.SwiperListDownloadFalg && this.InformationArrFalg) {
						this.loading.close()
					}
				} else {
					this.$message.warning(message)
				}
			},
			// 预警列表
			async HomeRemindGetForWarning() {

				let {
					code,
					message,
					data
				} = await HomeRemindGetForWarning({
					Type: this.Type,
					pageSize: 12,
					pageIndex: 1
				})
				if (code == 0) {
					this.WarningData = data.data
					this.WarningFalg = true
					if (this.WarningFalg && this.SwiperListDownloadFalg && this.InformationArrFalg) {
						this.loading.close()
					}
				} else {
					this.$message.warning(message)
				}
			},
			TitleClick(item) {
				this.Type = item.Value
				this.HomeRemindGetForWarning()
			},
			// 下载文件列表
			async DataDownloadListApi() {

				let {
					code,
					message,
					data
				} = await DataDownloadListApi({
					pageSize: 10,
					pageIndex: 1
				})
				if (code == 0) {
					this.SwiperList = data.data
					this.SwiperListDownloadFalg = true
					if (this.WarningFalg && this.SwiperListDownloadFalg && this.InformationArrFalg) {
						this.loading.close()
					}
				} else {
					this.$message.warning(message)
				}
			},
			async CusType() {
				let {
					code,
					data
				} = await CusType({})
				if (code == 0) {
					if (data.CusType == "") {
						this.CusTypestate = 0
					}
					if (data.CusType != "") {
						this.CusTypestate = 1
					}
				}
			},

		}
	}
</script>

<style lang="less" scoped>
	.WarningCenterStyle {
		width: 1200px;
		margin: 0 auto;
		// background-color: transparent;
	}

	.RealTimeinfo {
		width: 1200px;
		margin: 0 auto;
	}

	.SwiperTowStyle {
		width: 100%;
		min-width: 1200px;
		margin: 0 auto;
		// border: 1px solid red;
		padding-top: 19px;
		padding-bottom: 19px;
		position: relative;

		.SwiperTowStyleLeft {
			display: inline-block;
			width: 800px;
			// border: 1px solid rebeccapurple;
		}

		.RealTimeinfoTowRight {
			margin-left: 20px;
			width: 382px;
			height: 320px;
			// border: 1px solid rgb(51, 153, 51);
		}
	}

	.IndexCenterStyle {
		width: 100%;
		min-width: 1200px;
		margin: -14px auto;
		// outline: 1px solid red;
		margin-top: 90px;
	}

	.DownloadMaterialsStyle {
		width: 100%;
		min-width: 1200px;
		margin: 0 auto;
	}

	.CompanyprofileStyle {
		width: 100%;
		min-width: 1200px;
		margin: 0 auto;
	}
</style>